import { CardRow } from 'components/CardRow';
import { ICONS, Icon } from 'components/Icon';
import { theme } from 'lib/theme';
import React from 'react';
import { useSelector } from 'hooks/useSelector';
import {
  selectAseExplorerOptionSize,
  selectAseFlagResults,
  selectAseStatus,
  selectAseTplFlags,
} from 'store/assessments/selectors';
import { Txt } from 'components/Txt';
import { View } from 'react-native';
import { Card } from 'components/Card';
import { ModalScreens } from 'components/Navigation/types';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL } from 'store/actions';
import { AssessmentStatusesEnum } from 'types/types';

export const ExplorerFlags: React.FC = () => {
  const dispatch = useDispatch();
  const explorerOptionSize = useSelector(selectAseExplorerOptionSize);
  const flags = useSelector(selectAseTplFlags);
  const flagResults = useSelector(selectAseFlagResults);
  const aseStatus = useSelector(selectAseStatus).id as AssessmentStatusesEnum;

  return (
    <Card margin={false}>
      {flags
        .filter(
          (flag) =>
            !!flagResults[flag.id] || flag.allowedStatuses.includes(aseStatus),
        )
        .map((flag) => {
          const flagResult = flagResults[flag.id];
          return (
            <CardRow
              compact={explorerOptionSize === 'small'}
              small={explorerOptionSize === 'small'}
              key={flag.id}
              label={flag.name}
              icon={flagResult ? ICONS.FlagSolid : ICONS.FlagLight}
              iconColor={flagResult ? theme.colors.green : undefined}
              placeholder="Not Set"
              onPress={() =>
                dispatch(
                  NAVIGATE_MODAL({
                    screen: ModalScreens.AseFlag,
                    params: {
                      flagId: flag.id,
                    },
                  }),
                )
              }
              childrenStyle={{
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              {flagResult && (
                <>
                  <View>
                    <Txt
                      style={{
                        textAlign: 'right',
                        maxWidth: 120,
                        color: theme.colors.fieldValueText,
                      }}
                      size="xsmall"
                      lineHeightNone
                      numberOfLines={1}
                    >
                      {flagResult.by.name}
                    </Txt>
                  </View>
                  {!!flagResult.comment && (
                    <Icon
                      source={ICONS.CommentLight}
                      style={{
                        marginLeft: theme.paddingHorizontal,
                        marginRight: 2,
                      }}
                      color={theme.colors.fieldValueText}
                    />
                  )}
                </>
              )}
            </CardRow>
          );
        })}
    </Card>
  );
};
